/* TEN BUT — Microsoft Clarity no frame principal, gateado pelo consent (fix da coleta morta).
 *
 * POR QUE ESTE ARQUIVO EXISTE: o app Clarity da Shopify vive no sandbox STRICT dos web
 * pixels (web worker, sem DOM) — o tag baixa lá dentro mas nunca executa na página, então
 * zero sessões desde ~junho/2026 (diagnóstico 2026-07-13: window.clarity undefined, sem
 * cookies _clck/_clsk, nenhum beacon). Clarity precisa do DOM para gravar → tag no tema.
 *
 * REGRAS:
 *  - Só carrega com consentimento de analytics (banner custom da Story 9.2). Fontes do
 *    estado: localStorage ten_but_cookie_consent (visitante que já escolheu) e o evento
 *    'tb:consent' disparado por ten-but-consent.js na hora da escolha (liga sem reload).
 *  - SEMPRE envia clarity('consentv2', ...): o Clarity exige sinal de consent explícito
 *    para tráfego EEA e DESCARTA a sessão sem ele — carregar o script não basta.
 *  - Padrão herdado dos módulos ten-but: IIFE + guard window.__tbClarityInit.
 */
(function () {
  if (window.__tbClarityInit) return;
  window.__tbClarityInit = true;

  /* Project ID do Clarity (público — aparece em qualquer request do tag). */
  var PROJECT_ID = 'x1vepm7rd9';

  /* ⚠️ Manter em sincronia com POLICY_VERSION de ten-but-consent.js: consent salvo em
     versão antiga de política não vale como consent (o modal vai re-perguntar). */
  var POLICY_VERSION = 1;
  var STORAGE_KEY = 'ten_but_cookie_consent';

  var loaded = false;

  function readSavedConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var saved = raw ? JSON.parse(raw) : null;
      if (saved && saved.v === POLICY_VERSION) {
        return { analytics: !!saved.analytics, marketing: !!saved.marketing };
      }
    } catch (e) {}
    return null;
  }

  /* Sinal de consent do Clarity (consentv2). O stub de fila do tag aceita a chamada
     antes do script chegar — o sinal é processado assim que ele carrega. */
  function signalConsent(state) {
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('consentv2', {
          analytics_Storage: state.analytics ? 'granted' : 'denied',
          ad_Storage: state.marketing ? 'granted' : 'denied'
        });
      }
    } catch (e) {}
  }

  function applyState(state) {
    if (!state) return;
    if (loaded) {
      /* Já carregado (ex.: re-consent na mesma página) → só atualiza o sinal. */
      signalConsent(state);
      return;
    }
    if (!state.analytics) return;
    loaded = true;

    /* Stub oficial do Clarity: enfileira chamadas até o tag executar. */
    window.clarity =
      window.clarity ||
      function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
    signalConsent(state);

    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.clarity.ms/tag/' + PROJECT_ID;
    var first = document.getElementsByTagName('script')[0];
    if (first && first.parentNode) {
      first.parentNode.insertBefore(s, first);
    } else {
      (document.head || document.documentElement).appendChild(s);
    }
  }

  /* Escolha feita AGORA nesta página (disparado por ten-but-consent.js). */
  document.addEventListener('tb:consent', function (e) {
    applyState(e && e.detail ? e.detail : null);
  });

  /* Visitante que já consentiu em visita anterior. */
  applyState(readSavedConsent());
})();
